import React, { Fragment } from 'react'
import Configurator from '../../../../configurator'
import Modal from '../../../../components/modal'
import SportSelection from '../../../../admin/components/shared/sport-selection/sport-selection'
import AddSport from '../../../../admin/components/shared/addSport'
import {
    i18nWrapper,
    withRouterConnectWrapper,
} from '../../../../validator'
import { loadSportsToStore } from '../../../../components/sports/helpers'
import OverlayLoader from '../../../../components/shared/overlay-loader'
import Button from '../../shared/sn-button'
import classnames from 'classnames'
import SnIcon from '../../shared/sn-icon'
import { isWebView } from '../../../../admin/actions/index'
import classNames from 'classnames'

const personAddCircle = '/images/profile/person-add-circle.svg'

/**
 * Button for making request for sportnections
 *
 * @inheritDoc sportnectionsStatus.request
 */
class SportnectionsRequestButton extends Configurator {
    state = {
        showSportsModal: false,
        addSportModal: false,
        selectedSports: [],
        sendingSportsBusy: false,
        friendshipId: null,
        friendshipIdBusy: false,
    }


    componentDidMount = () => {
        if (isWebView()) {
            this.executeStatusChange()
        }
    }
    /**
     * Hide specific modal handler
     *
     * @param {string} modalState   - what modal will be hidden?
     * @return {void}
     */
    hideModal = modalState => this.setState({ [modalState]: false })

    /**
     * Show specific modal handler
     *
     * @param {string} modalState   - what modal will be showed?
     * @return {void}
     */
    showModal = modalState => this.setState({ [modalState]: true })

    /**
     * Update selected sports
     *
     * @param {array} selectedSports
     * @return {void}
     */
    updateSelectedSports = selectedSports => this.setState({ selectedSports })

    /**
     * Execute status change
     *
     * @return {Promise}
     */
    executeStatusChange = () => {
        const {
            match: {
                params: {
                    friendshipId,
                },
            },
        } = this.props

        let promises = []
        if (this.props.setStatus) {
            const { setStatus } = this.props

            promises = [
                setStatus(null, 0, null),
                this.showModal('showSportsModal'),
            ]
        }

        if (!this.props.sportsData) {
            promises.push(loadSportsToStore())
        }

        if (isWebView()) {
            this.setState(
                { friendshipId: parseInt(friendshipId) })
        }

        this.setState({ friendshipIdBusy: true })

        return Promise.all(promises)
            // eslint-disable-next-line camelcase
            .then(response =>
                this.setState(
                    {
                        friendshipId: isWebView() ?
                            parseInt(friendshipId) :
                            response?.[0]?.apiResponse?.data?.data?.friendshipId?.data?.friendship_id,
                    }
                )
            )
            .finally(() => this.setState({ friendshipIdBusy: false }))
    }

    /**
     * Send sports
     *
     * @param {boolean} skip
     * @return {Promise}
     */
    sendSports = skip => {
        const {
            friendshipId,
            selectedSports,
        } = this.state

        if (skip) {
            return this.sendSportSuccess()
        }

        const data = {
            friendship_id: friendshipId,
            sports: selectedSports?.map?.(selectedSport => selectedSport?.id),
        }

        if (selectedSports.length > 0) {
            this.setState({ sendingSportsBusy: true })

            return this.axios.post(`${this.config.REACT_APP_API_URL}api/friendship-user-sport`, data)
                .then(() => this.sendSportSuccess())
        }

        return this.sendSportSuccess()
    }

    /**
     * Success action after sport sending successfully
     *
     * @return {Promise}
     */
    sendSportSuccess = () => {
        const {
            successCallback,
            t,
        } = this.props

        const onSuccess = () => successCallback && typeof successCallback === 'function' ? successCallback : window.location.reload()

        return new Promise(resolve => resolve(
            window.swalert(t('sportnectionsSports.requestSend'), 'success', onSuccess)
        ))
    }


    renderContent = () => {
        const {
            selectedSports,
            sendingSportsBusy,
            friendshipIdBusy,
        } = this.state

        const {
            t,
            sportsData,
        } = this.props
        return (
            <Fragment>
                <div className="modal-body d-flex flex-column">
                    <div className="mb-3">
                        {t('sportnectionsSports.content')}
                    </div>
                    <SportSelection
                        sports={sportsData}
                        addSportHandle={() => {
                            this.showModal('addSportModal')
                            this.hideModal('showSportsModal')
                        }}
                        updateSelectedSports={this.updateSelectedSports}
                        selectedSports={selectedSports}
                    />
                </div>
                <div className="modal-footer">
                    <div className="d-flex justify-content-between align-items-center w-100">
                        <Button
                            className={classnames({
                                'btn btn-outline-color-gray-dark-3': true,
                                'btn-loading': sendingSportsBusy || friendshipIdBusy,
                            })}
                            onClick={() => this.sendSports(true)}
                        >
                            {t('sportnectionsSports.skip')}
                        </Button>
                        <Button
                            className={classnames({
                                'btn btn-color-brand': true,
                                'btn-loading': sendingSportsBusy || friendshipIdBusy,
                            })}
                            onClick={() => this.sendSports(false)}
                        >
                            {t('sportnectionsSports.submit')}
                        </Button>
                    </div>
                </div>
            </Fragment>

        )
    }

    /**
     * Render sports modal
     *
     * @return {*}
     */
    renderSportsModal = () => {
        const { showSportsModal } = this.state

        const {
            sportsBusy,
            t,
        } = this.props

        if (!showSportsModal) {
            return null
        }

        if (sportsBusy) {
            return <OverlayLoader />
        }

        return (
            <Modal
                content={() => this.renderContent()}
                handleHideModal={() => this.sendSports(true)}
                description={
                    <div className="d-flex align-items-center">
                        <h6 className="m-0">
                            {t('sportnectionsSports.title')}
                        </h6>
                    </div>
                }
                keyboard={false}
                backdrop={true}
            />
        )
    }

    /**
     * Render
     *
     * @return {*}
     */
    render() {
        const {
            text,
            skipSports,
            onClick,
            squareLook,
        } = this.props
        const { addSportModal } = this.state

        return (
            <Fragment>
                {!isWebView() &&
                    <Button
                        className={classNames({
                            'no-focus-outline': true,
                            'u-circle': !squareLook,
                            'u-square d-flex flex-row align-items-center h-100': squareLook,
                        })}
                        onClick={onClick ? onClick : () => this.executeStatusChange()}
                    >
                        {!squareLook &&
                            <div className="u-circle__icon">
                                <SnIcon className="sn-lg sn-substitute-circle-empty" />
                            </div>
                        }
                        {squareLook &&
                            <img
                                src={personAddCircle}
                                className="mr-1"
                            />
                        }
                        {text}
                        {(!skipSports && addSportModal) &&
                            <AddSport
                                toggleModal={() => {
                                    this.hideModal('addSportModal')
                                    this.showModal('showSportsModal')
                                }}
                            />
                        }
                    </Button>
                }
                {isWebView() && this.renderContent()}
                {!isWebView() && this.renderSportsModal()}
            </Fragment>
        )
    }
}

export default withRouterConnectWrapper(state => ({
    sportsBusy: state.sports.busy,
    sportsData: state.sports.data,
}))(i18nWrapper(SportnectionsRequestButton))
